<template>
  <div v-if="marche">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('detailMarche.title', { libelle: marche.libelle })}}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <button
              @click="checkPermissions(permissions.maj) ? $router.push({
                name: 'm.presse.marche-edit',
                params: { id: marche.id },
              }) : showPopUpPermission()"
              :class="{'button-access-no-permission':
                !checkPermissions(permissions.maj)}"
              class="button is-addOrEdit">
              <span>
                {{ $t('general.button.edit') }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="tab">
      <ul>
        <li
          v-for="(tab, index) in tabs" :key="index"
          :class="{'is-active': activeTab === tab}"
          @click="activeTab = tab">
          {{ $t(`detailMarche.tabs.${tab}`) }}
        </li>
      </ul>
    </div>
    <section class="corps">
      <component
        :is="activeTab"
        :marche="marche"
        detail/>
    </section>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { get as getMarche } from '@/api/achat/marche';
import messageErreur from '@/services/general/messageErreur';
import { postGetData } from '@/services/achat/marche/formatageMarche';
import AppBreadcrumb from '@/components/general/breadcrumb';
import Informations from '@/components/achat/marche/informations';
import { MARCHE } from '@/configuration/achat/permissionsConf';
import Produits from '@/components/achat/marche/produits';
import Fournisseur from '@/components/achat/marche/fournisseurs/listeFournisseur';
import VentesMarche from '@/components/achat/marche/ventesMarche/listeVentesMarche';

const Permissions = createNamespacedHelpers('permissions');
const Attachments = createNamespacedHelpers('attachments');

export default {
  components: {
    AppBreadcrumb,
    Informations,
    Produits,
    Fournisseur,
    VentesMarche,
  },
  data() {
    return {
      permissions: MARCHE,
      marche: null,
      activeTab: 'informations',
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    tabs() {
      return ['informations', 'produits', 'fournisseur', 'ventesMarche'];
    },
    breadcrumb() {
      return [
        { title: this.$i18n.t('detailMarche.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('detailMarche.breadcrumb.liste'), route: { name: 'l.presse.marche' }, isActive: false },
        { title: this.$i18n.t('detailMarche.breadcrumb.detail', { libelle: this.marche.libelle }), route: { name: '' }, isActive: true },
      ];
    },
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    ...Permissions.mapActions({
      showPopUpPermission: 'showPopup',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    const { id, activeTab } = this.$route.params;
    try {
      await this.setAttachmentContext({ module: 'Marche' });
      const marche = (await getMarche(id)).data.result;
      this.libelle = marche.libelle;
      if (this.tabs.includes(activeTab)) this.activeTab = activeTab;
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.libelle }));
      await this.setAttachmentElementId({ id: marche.id });
      this.marche = postGetData(marche);
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};
</script>
